import { render, staticRenderFns } from "./GdprCompliance.vue?vue&type=template&id=1f766df4&"
import script from "./GdprCompliance.vue?vue&type=script&lang=ts&"
export * from "./GdprCompliance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports